const Twitter = () => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64">
      <path
        d="M20.13 58a37.124 37.124 0 0 0 34.573-23.02 37.112 37.112 0 0 0 2.78-14.33v-1.715A27.343 27.343 0 0 0 64 12.157a27.086 27.086 0 0 1-7.535 2.066 13.264 13.264 0 0 0 5.819-7.272 25.863 25.863 0 0 1-8.32 3.2 13.15 13.15 0 0 0-22.4 11.954 37.212 37.212 0 0 1-27.055-13.7 13.117 13.117 0 0 0 4.073 17.453 13.006 13.006 0 0 1-5.818-1.63v.146A13.175 13.175 0 0 0 13.09 37.318c-1.898.51-3.886.59-5.818.233a13.118 13.118 0 0 0 12.16 8.988 26.329 26.329 0 0 1-16.32 5.817A28.452 28.452 0 0 1 0 52.094a37.153 37.153 0 0 0 20.13 5.818"
        fill="currentColor"
      />
    </svg>
  );
};

export default Twitter;
